import React from "react";
import { Link } from "react-router-dom";

const Projects = () => {
  
  return (
    <div className="py-12" id="projects">
      <h1 className="text-2xl font-bold ">
        03.<span className="text-primary">The_Best_Projects </span>
      </h1>
      <h1 class="mb-4 text-base font-normal text-gray-500 dark:text-gray-400 py-2">I have done more then 100+ projects. All projects responsive and perfect for all user.</h1>


      <div className="grid   mt-4 justify-content-center sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12">
        {/* ............................... */}
        <div className="card w-84  shadow-xl text-gray-300 ">
          <figure>
            <img
              className="h-[200px]"
              src="https://i.ibb.co/pd84qBk/Moza-Baba-4.png"
              alt="Shoes"
            />
          </figure>
          <div className="card-body">
            <h2 className="card-title">Buybaba E-commerce Website</h2>
            <div className="card-actions">
              <div className="badge badge-outline skill-border-react">
                React
              </div>
              <div className="badge badge-outline skill-border-react">
                Typescript
              </div>
              <div className="badge badge-outline skill-border-react">
                NodeJS
              </div>
              <div className="badge badge-outline skill-border-react">
                ExpressJS
              </div>
              <div className="badge badge-outline skill-border-react">
                MongoDb
              </div>
              <div className="badge badge-outline skill-border-react">
                Tailwind
              </div>
            </div>
            <p>This is full-stack website. A Learning Management Website</p>
            <div className="flex justify-between">
              <a target="_blank" href="https://mozababa.netlify.app/">
                <div className="badge badge-outline px-4 live-button  bg-primary  ">
                  live
                </div>
              </a>
              <a target="_blank" href="https://github.com/mozahidahmed/Head_phone">
                <div className="badge badge-outline px-4 live-button">Git</div>
              </a>
            </div>
          </div>
        </div>
        {/*....................................  */}
        {/* ............................... */}
        <div className="card w-84  shadow-xl text-gray-300 ">
          <figure>
            <img
              className="h-[200px]"
              src="https://i.ibb.co/c1FmKns/taskla.png"
              alt="Shoes"
            />
          </figure>
          <div className="card-body">
            <h2 className="card-title">Taskla(LMS) Website</h2>
            <div className="card-actions">
              <div className="badge badge-outline skill-border-react">
                React
              </div>
              <div className="badge badge-outline skill-border-react">
                Typescript
              </div>
              <div className="badge badge-outline skill-border-react">
                NodeJS
              </div>
              <div className="badge badge-outline skill-border-react">
                ExpressJS
              </div>
              <div className="badge badge-outline skill-border-react">
                MongoDb
              </div>
              <div className="badge badge-outline skill-border-react">
                Tailwind
              </div>
            </div>
            <p>This is full-stack website. A Learning Management Website</p>
            <div className="flex justify-between">
              <a target="_blank" href="https://taskla-hr.netlify.app/">
                <div className="badge badge-outline px-4 live-button  bg-primary  ">
                  live
                </div>
              </a>
              <a target="_blank" href="https://github.com/ranawp/taskla">
                <div className="badge badge-outline px-4 live-button">Git</div>
              </a>
            </div>
          </div>
        </div>
        {/*....................................  */}

        {/* ............................... */}
        <div className="card w-84  shadow-xl text-gray-300">
          <figure>
            <img
              className="h-[200px]"
              src="https://i.ibb.co/wBnDKXR/Manufacture.png"
              alt="Shoes"
            />
          </figure>
          <div className="card-body">
            <h2 className="card-title">Parts Manufacture Website</h2>
            <div className="card-actions">
              <div className="badge badge-outline skill-border-react">
                React
              </div>

              <div className="badge badge-outline skill-border-react">
                NodeJS
              </div>
              <div className="badge badge-outline skill-border-react">
                ExpressJS
              </div>
              <div className="badge badge-outline skill-border-react">
                MongoDb
              </div>
              <div className="badge badge-outline skill-border-react">
                Tailwind
              </div>
            </div>
            <p>This is full-stack website. Parts Manufacture Website.</p>
            <div className="flex justify-between">
              <a target="_blank" href="https://mechanicalparts.netlify.app/">
                <div className="badge badge-outline px-4 live-button  bg-primary  ">
                  live
                </div>
              </a>
              <a target="_blank"  href="https://github.com/mozahidahmed/manufacture-client-site">
                <div className="badge badge-outline px-4 live-button">Git</div>
              </a>
            </div>
          </div>
        </div>
        {/*....................................  */}
       
       
      </div>
      <Link to="allproject">
        <div className="grid justify-center mt-4 h1p">
          <button type="button" class="bg-gray-800 text-white rounded-r-md py-2 border-l border-gray-200 hover:bg-primary hover:text-white px-3">
            <div class="flex flex-row align-middle">
              <span class="mr-2">Let's  More Projects</span>
              <svg class="w-5 ml-2" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" d="M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z" clip-rule="evenodd"></path>
              </svg>
            </div>
          </button>
        </div>
      </Link>
      
    </div>
  );
};

export default Projects;
